export default __webpack_public_path__ + "static/media/Hood of Quilled Darts.1173b2d0.jpg";